var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 150,
    viewBox: "0 0 187 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_229_1142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.175 122.006C156.499 156.763 186.667 168.326 187 168.474C186.745 169.288 182.185 184.96 171.112 201.133C161.54 215.118 151.605 229.064 135.952 229.349C120.574 229.633 115.631 220.228 98.0461 220.228C80.4612 220.228 74.9788 229.055 60.4245 229.633C45.3209 230.202 33.8167 214.5 24.1661 200.564C4.43333 172.063 -10.631 120.005 9.60189 84.8645C19.6546 67.4169 37.622 56.3638 57.1193 56.0794C71.9483 55.795 85.9534 66.0635 95.0254 66.0635C104.097 66.0635 121.104 53.7256 138.993 55.5302C146.476 55.844 167.503 58.5509 180.998 78.313C179.909 78.9898 155.92 92.9557 156.175 122.006ZM127.273 36.6703C135.295 26.9609 140.689 13.4461 139.218 0C127.655 0.460953 113.679 7.6989 105.392 17.4083C97.9578 25.9997 91.4555 39.7499 93.211 52.9312C106.098 53.9316 119.26 46.3798 127.282 36.6703",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_229_1142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 229.653,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.4b81097d0b768217aba9dee3484c20a8.svg";
export { ForwardRef as ReactComponent };